import React from "react";
import MetaTags from "react-meta-tags";
import { Container} from "reactstrap";

import Widget from './Widget';
import Widget2 from './Widget2';


//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";


const Dashboard = () => {

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> tccontrol | Dashboard</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"tccontrol"} breadcrumbItem={"Dashboard"} />


              <Widget2 />
              <Widget /> 

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
